<!--
 * @Date: 2019-12-18 17:08:30
 * @LastEditors  : guantingting
 * @LastEditTime : 2019-12-18 17:12:42
 -->
<template lang="html">
  <div
    class="data-null"
    :style="{ 'padding-top': top, 'padding-bottom': bottom }"
  >
    <img v-if="image" :src="image" alt="" />
    <!-- <img v-else src="//st.haiziwang.com/static/b2c/sale/sale_common/css/images/fail.png" alt=""> -->
    <div
      v-else
      class="new-fail"
      :class="errorClass ? errorClass : 'kwstatus-fail'"
    ></div>
    <p class="title" v-show="title">{{ title }}</p>
    <p class="text" v-html="text"></p>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String
    },
    errorClass: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '2.8rem'
    },
    bottom: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin.scss';
.data-null {
  padding-top: rem(280px);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: rem(200px);
    margin-bottom: rem(24px);
  }
  .new-fail {
    min-width: rem(280px);
    min-height: rem(280px);
    margin-bottom: rem(24px);
  }
  .title {
    color: #121212;
    font-size: rem(32px);
    margin: 0 rem(75px) rem(12px);
  }
  .text {
    margin: 0 rem(75px);
    color: #999999;
    font-size: rem(28px);
    text-align: center;
    line-height: rem(40px);
  }
  // &.inside{
  //     padding-top: 10%;
  //     img{
  //         width: 40%;
  //     }
  // }
}
</style>
